export const TRIPMONEY_DOMAIN_NAME = {
  MMT: [
    "tripmoney.makemytrip.com",
    "insurance.makemytrip.com",
    "www.makemytrip.com",
  ],
  GI: ["tripmoney.goibibo.com", "insurance.goibibo.com", "www.goibibo.com"],
  TRIPMONEY: ["www.tripmoney.com"],
};

export enum PARTNER_DOMAIN_NAME {
  MMT = ".makemytrip.com",
  GI = ".goibibo.com",
  TRIPMONEY = "tripmoney.com",
}
